import { OnInit } from '@angular/core';
import { Component } from '@angular/core';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    ngOnInit() {
        this.model = [
            {
                label: 'ApiClients',
                icon: 'pi pi-fw pi-users',
                items: [
                    {
                        label: 'ApiClient1',
                        icon: 'pi pi-fw pi-key',
                    routerLink: ['/configuration/apiclient-environment-key'],
                    }
                ]
            }
        ];
    }
}
